const READ = 'read';
const EDIT = 'edit';
const DELETE = 'delete';

/**
 * @type {[
* READ,
* EDIT,
* DELETE,
* ]}
*/
const ACCESS_RIGHTS = [
  READ,
  EDIT,
  DELETE,
];

/** @typedef {typeof ACCESS_RIGHTS} AccessRights */
/** @typedef {keyof AccessRights} AccessRightsKey */
/** @typedef {AccessRights[AccessRightsKey]} AccessRightsValue */

module.exports = {
  READ,
  EDIT,
  DELETE,
  ACCESS_RIGHTS,
};
